
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[id]",
      function () {
        return require("private-next-pages/u/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[id]"])
      });
    }
  